// extracted by mini-css-extract-plugin
export default {"moreButton":"MoreButton-module__moreButton","popoverContent":"MoreButton-module__popoverContent","popoverContentWrap":"MoreButton-module__popoverContentWrap"};